import { Modal, ProgressBar, Row, Table } from 'react-bootstrap';
import styled from 'styled-components';
import { CustomDropdownStyle } from '../../../app/components/styledComponents/StyledCustomDropdown';
import { ForumStyled } from '../../forum/assets/styles/forumStyled';
import { MarketplaceStyled } from '../../marketplace/assets/marketplaceStyle';

export const ActivityTabs = styled.div`
  font-size: 18px;
  border: 1px solid ${({ theme }) => theme.lightGray1};
  padding: 5.5px;
  border-radius: 8px;
  display: flex;
  margin-bottom: 24px;
  overflow-x: auto;
  > span {
    white-space: nowrap;
    padding: 10px ${({ underline }) => (underline === 'fit' ? 0 : '40px')};
    border-radius: 6px;
    margin: 0 20px;
    justify-content: space-between;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.primaryDark};
    cursor: pointer;
    position: relative;
    font-weight: 500;
    &:before {
      position: absolute;
      content: '';
      bottom: -5px;
      height: 4px;
      border-radius: 10px 10px 0 0;
      background: ${({ theme }) => theme.primary};
      left: 0;
      right: 0;
      opacity: 0;
    }
    &.active {
      color: ${({ theme }) => theme.primary};
      &:before {
        opacity: 1;
      }
    }
  }
`;

export const ItemHeading = styled.h3`
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: 500;
  margin-bottom: 12px;
  @media screen and (max-width: 767px) {
    font-size: 18px;
    line-height: 23px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const IconOutside = styled.div`
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => `${theme.primary}1a`};
  border-radius: 4px;
  position: relative;
  &:before {
    position: absolute;
    content: '';
    right: -24px;
    height: 48px;
    width: 5px;
    border-radius: 10px 0px 0 10px;
    background: ${({ theme }) => theme.primary};
  }
  svg {
    color: ${({ theme }) => theme.primary};
    height: 24px;
    width: 24px;
  }
`;
export const ActivityCard = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.lightGray1};
`;
export const ActivityFlex = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 36px;
  h5 {
    font-size: 18px;
    line-height: 22px;
    padding-top: 12px;
  }
  span {
    padding: 4px 8px;
    border-radius: 7px;
  }
`;
export const ActivityCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    font-size: 32px;
    line-height: 40px;
    color: ${({ theme }) => theme.primaryDark};
  }
  p {
    color: ${({ theme }) => theme.primary};
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    svg {
      margin-left: 10px;
    }
  }
`;
export const ActivityTabsSecondary = styled.div`
  border: 1.5px solid ${({ theme }) => theme.lightGray1};
  padding: 4px;
  border-radius: 8px;
  display: flex;
  max-width: 350px;
  margin-top: 12px;
  margin-bottom: 4px;
  span {
    padding: 8px 14px;
    border-radius: 6px;
    flex: 1;
    text-align: center;
    font-size: 16px;
    color: ${({ theme }) => theme.primaryDark};
    cursor: pointer;
    line-height: 24px;
    font-weight: 500;
    &.active {
      background-color: ${({ theme }) => theme.mainPrimary};
      color: ${({ theme }) => theme.white};
    }
  }
`;
export const ActivityTableWrapper = styled.div`
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  margin-top: 12px;
  border: 1px solid ${({ theme }) => theme.lightGray1};
  &.my-activity-table-wrapper {
    @media screen and (max-width: 767px) {
      background-color: transparent;
      border: 0;
    }
  }
  table {
    thead {
      th {
        font-weight: 500 !important;
      }
    }
    tbody {
      tr {
        &:nth-child(odd) {
          td {
            background-color: ${({ theme }) => theme.lightGray2};
          }
        }
        td {
          span {
            &:nth-child(2) {
              color: ${({ theme }) => theme.primary};
            }
          }
        }
      }
    }
  }
  .activity-table {
    border: 0;
    table {
      margin-bottom: 0;
      thead {
        th {
          padding: 16px 24px;
        }
      }
      tbody {
        tr {
          td {
            padding: 18px 24px;
          }
          &:nth-child(odd) {
            td {
              background-color: inherit;
            }
          }
        }
      }
    }
  }
`;
export const ActivityTableFilter = styled.div`
  padding: 24px 24px 0 24px;
  background-color: ${({ theme }) => theme.white};
  @media screen and (max-width: 767px) {
    padding: 8px;
    margin-bottom: 4px;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.inputBorder};
  }
`;
export const Sidebar = styled.div`
  padding: 16px;
  border: 1px solid ${({ theme }) => theme.inputBorder};
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  margin-left: 24px;
  max-width: 319px;
  @media screen and (max-width: 1199px) {
    margin-left: 0px;
    max-width: inherit;
  }
`;
export const SidebarSection = styled.div`
  background-color: ${({ theme }) => theme.lightGray2};
  padding: 24px;
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
  .income-summary {
    > * {
      padding: 0px 6px;
    }
    .income-card {
      &:not(:last-child) {
        margin-bottom: 12px;
      }
      @media screen and (max-width: 1139px) {
        width: 50%;
        flex: 0 0 auto;
      }
      @media screen and (max-width: 899px) {
        width: 100%;
        flex: 0 0 auto;
      }
    }
  }
`;
export const SidebarSectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  h4 {
    color: ${({ theme }) => theme.primaryDark};
    font-size: 18px;
    line-height: 23px;
    font-weight: 500;
    margin-bottom: 0;
  }
  svg {
    color: ${({ theme }) => theme.primary};
  }
`;

export const ProductDetail = styled.div`
  display: flex;
`;
export const ProductImg = styled.div`
  margin-right: 12px;
  img {
    height: 75px;
    width: 75px;
    object-fit: cover;
    border-radius: 4px;
  }
`;
export const ProductInfo = styled.div`
  h4 {
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 20px;
    color: ${({ theme }) => theme.primaryDark};
  }
  & > span {
    padding: 4px 12px;
    margin-bottom: 12px;
    display: inline-block;
  }
  p {
    color: ${({ theme }) => theme.primaryDark};
    margin-bottom: 10px;
    span {
      font-size: 24px;
      line-height: 30px;
    }
  }
  .view-detail {
    color: ${({ theme }) => theme.primary};
    svg {
      height: 20px;
      width: 20px;
      margin-left: 8px;
    }
  }
`;
export const IncomeCard = styled.div`
  padding: 16px;
  border-radius: 7px;
  background-color: ${({ theme }) => theme.white};
  &:not(:last-child) {
    margin-bottom: 12px;
  }
  .income-detail {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    margin-left: 8px;
    color: ${({ theme }) => theme.primaryDark};
    h6 {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 4px;
      font-weight: 500;
    }
    p {
      font-size: 12px;
    }
  }
  span {
    padding: 4px 8px;
  }
`;
export const IncomeStats = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`;
export const MyActivity = styled.div`
  width: calc(100% - 342px);
  @media screen and (max-width: 1199px) {
    width: 100%;
    margin-bottom: 16px;
  }
  .my-activity-tab {
    justify-content: space-between;
    > span {
      padding: 15px 17px;
    }
  }
`;
export const ReviewProductImg = styled.div`
  img {
    height: 122px;
    width: 122px;
    border-radius: 6px;
    margin-right: 16px;
  }
`;

export const WriteReviewModal = styled(Modal)`
  .modal-dialog {
    max-width: 589px;
  }
`;

export const ReviewProductInfo = styled.div`
  h4 {
    font-size: 18px;
    line-height: 22px;
    color: ${({ theme }) => theme.primaryDark};
    font-weight: 500;
    margin-bottom: 0;
    &.reviewItemTitle {
      opacity: 0.8;
      margin-bottom: 8px;
    }
  }
  span {
    padding: 4px 12px;
    font-weight: 400;
    display: inline-block;
    margin-bottom: 12px;
  }
`;
export const OverAllRating = styled.div`
  padding: 24px 0;
  border-top: 1px solid ${({ theme }) => theme.inputBorder};
  border-bottom: 1px solid ${({ theme }) => theme.inputBorder};
  text-align: center;
  p {
    font-size: 14px;
    line-height: 17px;
    color: ${({ theme }) => theme.primaryDark};
    font-weight: 400;
    margin-bottom: 14px;
  }
  svg {
    margin-right: 16px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
export const BuyingRequestPagination = styled(ForumStyled.FooterPagination)`
  margin-inline: 42px;
  margin-bottom: 17px;
`;
export const BuyingRequestTable = styled(Table)`
  thead {
    tr {
      th {
        text-align: left !important;
        &:first-child {
          padding-left: 42px;
        }
      }
    }
  }
  tbody {
    tr {
      td {
        text-align: left !important;
        &:first-child {
          padding-left: 42px;
          width: 10%;
        }
        &:nth-child(3) {
          font-size: 14px !important;
          font-weight: 400 !important;
        }
      }
    }
  }
`;
export const PromoteStore = styled(SidebarSection)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  min-height: 213px;
  padding: 28px 24px;
  h4 {
    font-size: 20px;
    line-height: 25px;
    font-weight: 500;
    max-width: 170px;
  }
  svg {
    position: absolute;
    right: 23px;
    top: 50%;
    transform: translateY(-50%);
  }
  button {
    padding: 8px 16px;
    font-size: 16px;
    line-height: 24px;
    height: fit-content;
  }
`;
export const ScavengerNotFound = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: calc(100vh - 250px);
  h2 {
    font-size: 32px;
    line-height: 24px;
    margin-top: 30px;
    margin-bottom: 0;
    font-weight: 500;
  }
  p {
    font-size: 18px;
    line-height: 24px;
    margin-top: 16px;
    font-weight: 400;
    margin-bottom: 0;
    color: ${({ theme }) => theme.placeholderColor};
  }
  button {
    margin-top: 24px;
  }
`;
export const ReviewsBox = styled.div`
  background-color: ${({ theme }) => theme.primaryLight2};
  padding: 14px 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  justify-content: between;
`;

export const TotalReviews = styled.div`
  width: 50%;
  h3 {
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 0;
    color: ${({ theme }) => theme.primaryDark};
    span {
      font-size: 20px;
      font-weight: 400;
    }
  }
  p {
    color: ${({ theme }) => theme.primaryDark};
    font-weight: 400;
    font-size: 14px;
  }
  svg {
    width: 16px;
    margin-right: 6px;
  }
`;

export const ReviewsProgressBar = styled.div`
  width: 40%;
  margin-left: auto;
`;

export const ProgressBarRating = styled(ProgressBar)`
  background-color: ${({ theme }) => theme.placeholderColor}26;
  flex: 1;
  height: 6px;
  margin: 0 10px;
  max-width: 46px;
  .progress-bar {
    background-color: ${({ theme }) => theme.yellow};
  }
`;

export const SingleProgressBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 400;
  font-size: 12px;
  color: ${({ theme }) => theme.primaryDark};
`;

export const UserReviews = styled.div`
  h5 {
    font-weight: 500;
    font-size: 18px;
    color: ${({ theme }) => theme.primaryDark};
  }
`;

export const UserReview = styled.div`
  border: 1px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  &:hover {
    > div div:last-child {
      visibility: visible;
    }
  }
  p {
    color: ${({ theme }) => theme.primaryDark};
    font-weight: 400;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 0;
  }
`;

export const ReviewUserInfo = styled.div`
  display: flex;
  img {
    width: 28px;
    height: 28px;
    border-radius: 100%;
    margin-right: 10px;
    object-fit: cover;
  }
`;
export const ReviewUser = styled.div`
  display: flex;
  align-items: center;
  h6 {
    margin-bottom: 0;
    margin-right: 5px;
    color: ${({ theme }) => theme.primaryDark};
    font-weight: 500;
    font-size: 14px;
  }
  span {
    color: ${({ theme }) => theme.placeholderColor};
    font-weight: 400;
    font-size: 12px;
  }
`;

export const ReviewsList = styled.div`
  max-height: 350px;
  overflow-y: auto;
`;

export const ReviewUserWrapper = styled.div``;

export const ReviewUserRating = styled.div`
  svg {
    width: 14px;
    height: 14px;
    margin-right: 5px;
    vertical-align: middle;
  }
  span {
    font-weight: 400;
    vertical-align: middle;
    color: ${({ theme }) => theme.primaryDark};
    font-size: 12px;
    padding-left: 2px;
  }
`;

export const ReviewUserAction = styled.div`
  margin-left: auto;
  visibility: hidden;
  svg {
    color: ${({ theme }) => theme.primary};
    margin-left: 10px;
  }
`;

export const NewRequestModal = styled(Modal)`
  color: red;
`;
export const ProposalDetail = styled.div`
  background-color: ${({ theme }) => theme.white};
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  @media screen and (max-width: 767px) {
    padding: 16px;
  }
  h4 {
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 8px;
  }
  > span {
    color: ${({ theme }) => theme.darkenText}99;
    margin-bottom: 12px;
    margin-top: 12px;
    display: block;
    font-weight: 500;
    @media screen and (max-width: 767px) {
      margin-bottom: 14px;
    }
  }
  p {
    color: ${({ theme }) => theme.darkenText};
    margin-bottom: 16px;
    font-size: 14px;
  }
  .scavenger-hunt-apply-button {
    .btn {
      height: 42px;
      padding: 8px 17px !important;
      line-height: 0;
      font-size: 16px;
    }
  }
`;
export const LocationMain = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.darkenText};
  font-weight: 500;
  svg {
    width: 17px;
    height: 20px;
    margin-right: 10px;
    vertical-align: bottom;
  }
`;
export const ProposalCard = styled.div`
  background-color: ${({ theme }) => theme.white};
  padding: 24px;
  border: 1px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  margin-top: 12px;
  @media screen and (min-width: 1200px) {
    .custom-drop-down {
      opacity: 0;
      transition: 0.1s all ease-in-out;
    }
    :hover {
      .custom-drop-down {
        opacity: 1;
        transition: 0.1s all ease-in-out;
      }
    }
  }
  @media screen and (max-width: 767px) {
    padding: 16px;
  }
`;

export const ProposalHead = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  h5 {
    font-size: 18px;
    font-weight: 500;
    color: ${({ theme }) => theme.darkenText};
    margin-bottom: 0;
  }
  .custom-drop-down {
    margin-left: auto;
    .dropdown-toggle {
      color: ${({ theme }) => theme.darkenText};
      cursor: pointer;
      &::after {
        content: normal;
      }
    }
    .dropdown-menu {
      inset: 10px 0 auto auto !important;
    }
  }
`;

export const ProposalInfo = styled.div`
  width: 60%;
  float: left;
  margin: auto 0;
  h3 {
    font-weight: 500;
    font-size: 24px;
    color: ${({ theme }) => theme.darkenText};
    margin-bottom: 8px;
  }
  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: ${({ theme }) => theme.darkenText};
  }
`;
export const ProposalBody = styled.div`
  display: flex;
  width: 100%;
  @media only screen and (min-width: 768px) and (max-width: 1099px) {
    gap: 10px;
  }
  @media screen and (max-width: 991px) {
    flex-wrap: wrap;
  }
`;

export const ProposalImg = styled.div`
  float: left;
  margin-right: 24px;
  max-width: 223px;
  width: 100%;
  height: 223px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.primaryLight};
  @media screen and (max-width: 1142px) {
    max-width: 200px;
    height: 200px;
  }
  @media screen and (max-width: 768px) {
    max-width: 122px;
    height: 122px;
    flex: 0 0 auto;
    margin-right: 16px;
  }
  img {
    max-width: 223px;
    width: 100%;
    height: 223px;
    object-fit: cover;
    border-radius: 5px;
    min-width: 223px;
    @media screen and (max-width: 1142px) {
      max-width: 200px;
      height: 200px;
    }
    @media screen and (max-width: 768px) {
      max-width: 122px;
      min-width: initial;
      height: 122px;
    }
  }
`;

export const Category = styled(MarketplaceStyled.Category)`
  padding: 4px 8px;
  min-width: 40px;
  text-align: center;
  margin-bottom: 16px;
  @media screen and (max-width: 767px) {
    margin-bottom: 12px;
  }
  ${({ theme, primary }) =>
    primary &&
    `
    background-color: ${theme.primary}1A;
    color: ${theme.primary};
    &:before { 
      content: '';
      background-color: ${theme.primary};
      width: 7px;
      height: 7px;
      border-radius: 50px;
      display: inline-block;
      margin-right: 5px;
    }
  `}
  &.interested-badge {
    min-width: auto;
  }
`;

export const ProposalUser = styled.div`
  display: flex;
  align-items: center;
  padding-top: 16px;
  img {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    margin-right: 12px;
  }
`;

export const ProposalUserInfo = styled.div`
  h6 {
    font-size: 16px;
    color: ${({ theme }) => theme.darkenText};
    margin-bottom: 5px;
    font-weight: 500;
  }
  p {
    font-size: 14px;
    color: ${({ theme }) => theme.darkenText};
    margin-bottom: 0;
    font-weight: 400;
  }
`;

export const ProposalRightInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: ${({ theme }) => theme.primaryDark};
    display: none;
    margin-top: 16px;
    margin-bottom: 0;
    @media screen and (max-width: 768px) {
      display: block;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  .proposal-card-buttons {
    width: max-content;
    margin-left: 10px;
    .chat-button {
      min-width: 118px;
      @media screen and (max-width: 1142px) {
        min-width: auto;
        font-size: 14px;
        height: 36px;
        padding: 6px 12px;
        svg {
          width: 16px;
          height: 16px;
        }
      }
    }
    .accept-proposal {
      min-width: 172px;
      @media screen and (max-width: 1142px) {
        min-width: auto;
        font-size: 14px;
        height: 36px;
        padding: 6px 12px;
      }
    }
  }
  @media screen and (max-width: 991px) {
    flex: 0 0 100%;
  }
`;
export const ProposalAction = styled.div`
  button {
    svg {
      vertical-align: middle;
      margin-right: 8px;
    }
  }
`;

export const ProposalDateInfo = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  margin-left: auto;
  svg {
    margin-right: 10px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    padding: 12px;
    background: ${({ theme }) => theme.badgeText}21;
    color: ${({ theme }) => theme.badgeText};
  }
`;

export const ProposalDate = styled.div`
  span {
    font-size: 18px;
    color: ${({ theme }) => theme.darkenText};
  }
  h4 {
    font-size: 18px;
    font-weight: 500;
    color: ${({ theme }) => theme.darkenText};
  }
`;
export const InterestedSubHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColorLight};
  margin-bottom: 6px;
  margin-top: 6px;
  h4 {
    font-size: 18px;
    font-weight: 500;
    margin: 0%;
    @media (max-width: 575px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
  span {
    font-size: 16px;
  }
`;
export const PreviewItem = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: ${({ theme }) => theme.primaryDark};
  margin-bottom: 12px;
`;
export const PreviewSlider = styled.div`
  .swiper-thumbs {
    .swiper-slide {
      img {
        height: 109px;
      }
    }
  }
`;
export const PreviewTitlePrice = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  h4 {
    font-weight: 500;
    color: ${({ theme }) => theme.primaryDark};
    font-size: 30px;
    @media screen and (max-width: 575px) {
      font-size: 18px;
      line-height: 23px;
    }
  }
  h5 {
    font-weight: 500;
    color: ${({ theme }) => theme.primaryDark};
    font-size: 28px;
    @media screen and (max-width: 575px) {
      font-size: 18px;
      line-height: 23px;
    }
  }
`;

export const ActivityCardWrapper = styled(Row)`
  .activity-card {
    @media screen and (max-width: 899px) {
      width: 100%;
      &:not(:last-child) {
        margin-bottom: 12px;
      }
    }
  }
`;

export const SellingItemPreview = styled.div`
  margin-top: auto;
  @media screen and (max-width: 991px) {
    margin-top: 16px;
  }
  button {
    @media screen and (max-width: 767px) {
      padding: 6px 12px;
      font-size: 14px;
      line-height: 24px;
      font-weight: 500;
      height: auto;
    }
  }
`;
export const SellingInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  @media only screen and (min-width: 768px) and (max-width: 1099px) {
    gap: 15px;
  }
  h3 {
    font-weight: 500;
    font-size: 24px;
    color: ${({ theme }) => theme.darkenText};
    margin-bottom: 8px;
    @media screen and (max-width: 767px) {
      font-size: 18px;
      line-height: 23px;
    }
  }
  p {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: ${({ theme }) => theme.darkenText};
    @media only screen and (min-width: 768px) and (max-width: 1099px) {
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
`;
export const ActivityTimeDropdown = styled(CustomDropdownStyle)`
  max-width: 160px;
  height: fit-content;
  .menu-toggle {
    &.table-dropdown {
      height: auto;
      padding: 11px 20px;
    }
  }
  .menu-dropdown {
    &.dropdown-menu {
      @media screen and (max-width: 450px) {
        min-width: 15rem;
      }
    }
  }
`;

export const MarketplaceActivityStyled = {
  ActivityTabs,
  IconOutside,
  ActivityCard,
  ActivityFlex,
  ActivityCardFooter,
  ActivityTabsSecondary,
  ActivityTableWrapper,
  ActivityTableFilter,
  Sidebar,
  SidebarSection,
  SidebarSectionTitle,
  ProductDetail,
  ProductImg,
  ProductInfo,
  IncomeCard,
  IncomeStats,
  PromoteStore,
  MyActivity,
  ItemHeading,
  ReviewProductImg,
  ReviewProductInfo,
  OverAllRating,
  WriteReviewModal,
  BuyingRequestTable,
  BuyingRequestPagination,
  ScavengerNotFound,
  ReviewsBox,
  TotalReviews,
  ReviewsProgressBar,
  ProgressBarRating,
  SingleProgressBar,
  UserReviews,
  UserReview,
  ReviewUserInfo,
  ReviewUser,
  ReviewUserRating,
  ReviewUserWrapper,
  ReviewUserAction,
  ReviewsList,
  NewRequestModal,
  ProposalDetail,
  LocationMain,
  ProposalCard,
  ProposalHead,
  ProposalBody,
  ProposalInfo,
  ProposalImg,
  Category,
  ProposalUser,
  ProposalUserInfo,
  ProposalRightInfo,
  ProposalAction,
  ProposalDateInfo,
  ProposalDate,
  InterestedSubHead,
  PreviewItem,
  PreviewSlider,
  PreviewTitlePrice,
  ActivityCardWrapper,
  ActivityTimeDropdown,
  SellingInfoWrapper,
  SellingItemPreview,
};
